import { render } from "./LiveDataForId.vue?vue&type=template&id=1ce5408b"
import script from "./LiveDataForId.vue?vue&type=script&lang=js"
export * from "./LiveDataForId.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__